export default __webpack_public_path__ + "static/media/enrichedNetwork.eea5782f.png";